import React, { useContext, useState, useEffect } from 'react';
import '../../App.css'
import { Button, Container, List, Typography } from '@mui/material';
import Layout from '../../component/Layout';
import { UserProfile } from '../../contexts/UserContext';
import { SystemProfile } from '../../contexts/SystemContext';
import TextField from '@mui/material/TextField';
import api from '../../connection/Axios';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import CustomText from '../../utilities/CustomDiv';


const AdicionarUsuario = () => {
  const [userData, setUserData] = useContext(UserProfile)
  const [systemData, setSystemData] = useContext(SystemProfile)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [success, setSuccess] = useState(true)
  const [role, setRole] = useState('')
  const [companyId, setCompanyId] = useState([])
  const [companyIdRole, setCompanyIdRole] = useState()
  const [companies, setCompanies] = useState([])
  const [accessId, setAccesId] = useState()
  const [showCompany, setShowCompany] = useState(false)
  const [data, setData] = useState()
  const password = "asadsda%4aksjd"

  useEffect(()=>{
    const randomId = Math.floor(Math.random() * 9999)
    setAccesId(randomId)

    if(role === 'cliente' || role === 'clienteAdm') {
      setCompanyIdRole('cliente')
      setRole('cliente')
      setShowCompany(false)
    }

  }, [])

  function ValidateEmail() {
    var re = /\S+@\S+\.\S+/;
    if (re.test(email) === true) {
        console.log('valida email passed')
        SaveSurveyor()
    } else {
        setSystemData({...systemData, erro : 'Digite um email válido', typeError : 'error'})
    }
  }

  const headers = {
    headers: {
      "Content-Type": "application/json", "Access-Control-Allow-Origin": "*",
      "Authorization": `Bearer ${userData.token}`
    }};

useEffect(()=>{
  if(companyId.length > 0){
    CreateData()
  } else {
    CreateData()
  }
}, [companyId, role])

function CreateData() {
  if(role === 'tecnico' || role === 'admin') {
    setData({
    "username": email,
    "name": name,
    "role": role,
    "accessId": accessId,
    "password": password
   })
  } else {
      setData({
      "username": email,
      "name": name,
      "role": userData.role === 'cliente' || userData.role === 'clienteAdm' ? 'cliente' : role,
      "accessId": accessId,
      "password": password,
      "companyId": userData.role === 'cliente' || userData.role === 'clienteAdm' ? userData.companyId : companyId[0]
      })
  }
}
  console.log('Dara ', data)


 console.log('access ', accessId, companyIdRole)

  async function SaveSurveyor() {
    await api.post('register/createUserTemp/', data, headers).then(response => {
      setSuccess(false)
    }).catch(error => {
      setSystemData({...systemData, erro: error.message, typeError: 'warning'})
    })
  }

  async function GetCompanies() {
    await api.get('company/getCompanies/', headers).then(response => {
    setCompanies(response.data)
    }).catch(error => {
    setSystemData({...systemData, erro: error.message, errorType: 'warning'})
    })
}

  function Reset() {
    setEmail('')
    setName('')
    setRole('')
    setCompanyId([])
    setCompanyIdRole('')
    setSuccess(true)
  }

  useEffect(()=>{
    GetCompanies()
  })

  function SetUserRole(value){
    setRole(value)
    if(value !== 'tecnico' && value !== 'admin') {
      setShowCompany(true)
    } else {
      setShowCompany(false)
    }
  }

  

  return (
    <>
        <Layout breadcrumb='Dashboard / Administradores / Adicionar usuário' title='Adicionar Usuário'>
          <Typography>Preencha os campos abaixo para criar um novo usuário comum:</Typography>
          <br />
          {success ?
          <>
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setName(event.target.value)} value={name} label="Nome" variant="outlined" style={{width: '100%'}} />
            
            <div style={styles.block}></div>
            <TextField  onChange={(event) => setEmail(event.target.value)} value={email} label="E-mail" variant="outlined" style={{width: '100%'}} />
            
            <div style={styles.block}></div>
            
            {userData.role === 'cliente' || userData.role === 'clienteAdm' ? null :
              <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }}>
                <InputLabel id="tipo de usuário">Selecione o tipo de usuário - {role}</InputLabel>
                <Select 
                    labelId="tipo de usuário"
                    label="Qual o papel que este usuário representará?"
                    value={role}
                    onChange={(event) => SetUserRole(event.target.value)}>
                    <MenuItem value='tecnico'>Técnico</MenuItem>
                    <MenuItem value='cliente'>Cliente</MenuItem>
                    <MenuItem value='admin'>EHS Administrador do sistema</MenuItem>
                </Select>
              </FormControl>
            }
            
            <div style={styles.block}></div>
            {showCompany === true ? 
            <FormControl sx={{ m: 1, minWidth: 120, width: '100%' }}>
                <InputLabel id="empresa">Selecione uma Empresa</InputLabel>
                <Select 
                    labelId="empresa"
                    label="Selecione uma empresa"
                    value={companyId != undefined ? `Empresa selecionada: ${companyId[1]} - ${companyId[0]}` : 'Todas as empresas'}
                    onChange={(event) => setCompanyId(event.target.value)}>
                    {companies.length != 0 ? companies.map((item, index) => (
                        <MenuItem key={index} value={[item.cnpj, item.nomeFantasia]}>{item.nomeFantasia}</MenuItem>
                    )) : null}
                </Select>
            </FormControl>
            : null }
            <div style={{marginBlock: 20}}>{role === 'clienteAdm' || role === 'cliente' ? `Empresa selecionada: ${companyId[0] !== undefined ? companyId[1] : ''} ${companyId[0] !== undefined ? '/' : ''}  ${companyId[0] !== undefined ? companyId[0] : ''}` : null}</div>
            

            <div style={styles.block}>
              <Button variant="contained" color='secondary' className='boto' style={{color: '#ffffff'}} onClick={()=>{ValidateEmail()}}>
                Adicionar
              </Button>
            </div>
          </>  
          :
          <>
            <div style={styles.block}></div>
            Usuário criado com sucesso.
            <div style={styles.block}></div>
            <CustomText style={{fontWeight: 600}}>Nome: </CustomText> {name}
            <CustomText style={{fontWeight: 600}}>E-mail: </CustomText> {email}
            <CustomText style={{fontWeight: 600}}>Tipo: </CustomText> Técnico
            <CustomText>{companyId != undefined ? `Empresa: ${companyId[1]}` : 'Equipe EHS' }</CustomText>
            
            <div style={styles.block}></div>
            <div style={styles.block}></div>
            <Button variant="contained" className='boto' style={{color: '#ffffff'}} onClick={()=>{Reset()}}>
              Cadastrar novo usuário
            </Button>
          </>
          }
        </Layout>
    </>
  );
};

export default AdicionarUsuario


const styles = {
  block: {
    marginTop: 10,
  }
}